import React, { useState } from 'react';

import { getAvatarUrl } from '../../utils/gravatarUtils';

interface AvatarProps {
  email?: string;
  username?: string;
  size?: number;
  className?: string;
  alt?: string;
  showTooltip?: boolean;
}

const Avatar: React.FC<AvatarProps> = ({
  email,
  username,
  size = 40,
  className = '',
  alt,
  showTooltip = false,
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const avatarUrl = getAvatarUrl(email, username, size);
  const displayName = username || email || 'User';
  const tooltipText = showTooltip ? displayName : undefined;

  const handleImageError = () => {
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  // エラーが発生した場合やロード中はフォールバック画像を表示
  const shouldShowFallback = imageError || !imageLoaded;

  return (
    <div
      className={`relative inline-block ${className}`}
      title={tooltipText}
      style={{ width: size, height: size }}
    >
      <img
        src={avatarUrl}
        alt={alt || displayName}
        className={`rounded-full object-cover transition-opacity duration-200 ${
          shouldShowFallback ? 'opacity-0' : 'opacity-100'
        }`}
        style={{ width: size, height: size }}
        onError={handleImageError}
        onLoad={handleImageLoad}
      />
      {shouldShowFallback && (
        <div
          className="absolute inset-0 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-medium"
          style={{ fontSize: size * 0.4 }}
        >
          {username ? username.charAt(0).toUpperCase() : '?'}
        </div>
      )}
    </div>
  );
};

export default Avatar;
